<template>
  <div>
    <el-tooltip placement="bottom" effect="light">
      <div slot="content" class="p-10">
        <el-table
          :data="alertsAux"
          class="table tableTooltip table-hover table-striped no-more-tables no-margin"
        >
          <el-table-column
            :formatter="formatDateHour"
            :label="i18nValues['dateAndTime']"
            align="center"
            width="130"
          />
          <el-table-column prop="warningMessage" :label="i18nValues['message']" align="left"></el-table-column>
          <el-table-column prop="hint" :label="i18nValues['help']" align="left"></el-table-column>
        </el-table>
      </div>
      <el-button
        v-if="alerts && alerts.length > 0"
        class="btn-tooltip text-dangerDash cardButton"
        size="small"
        icon="nc-icon nc-alert-circle-i"
      >{{i18nValues['alerts']}}</el-button>
      <div v-else class="noAlert"></div>
    </el-tooltip>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "AlertsDashboardTemplate",
  created: function() {
    this.alertsAux = [];
    this.alertsAux = this.alertsAux.concat(this.alerts);
  },
  watch: {
    alerts: function() {
      this.alertsAux = [];
      this.alertsAux = this.alertsAux.concat(this.alerts);
    }
  },
  props: {
    alerts: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      alertsAux: []
    };
  },
  methods: {
    formatDateHour: function(value) {
      let auxDate = moment(value.createTimestamp, "YYYY-MM-DDTHH:mm:ss.SSSZ");
      if (auxDate.isValid()) return auxDate.format("DD/MM/YYYY HH:mm");
      else return undefined;
    }
  }
};
</script>
<style>
.btn-tooltip {
  border: 0px !important;
  background-color: white !important;
}
.btn-tooltip:hover,
.btn-tooltip:focus {
  background-color: white !important;
}
.btn-tooltip {
  font-size: 14px !important;
  padding: 0px 0px;
}
.noAlert {
  margin: 18px;
}
</style>